import { Link } from "gatsby"
import Container from "components/ui/Container"

const MODELS = [
  { name: "Preset Cloud", path: "/preset-cloud/", desc: "Fully managed SaaS" },
  {
    name: "Managed Private Cloud",
    path: "/preset-managed-private-cloud/",
    desc: "Managed in your VPC",
  },
  {
    name: "Preset On-Prem",
    path: "/preset-on-prem/",
    desc: "Self-operated, air-gap ready",
  },
  {
    name: "Preset Certified Superset",
    path: "/certified-superset/",
    desc: "Self-operated, open-source",
  },
]

function DeploymentCalloutSection() {
  return (
    <Container section>
      <div className="rounded-2xl bg-catskill-white px-8 py-10 md:px-12 md:py-12">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div className="max-w-sm">
            <p className="text-sm font-bold uppercase tracking-widest text-azure">
              Deploy Anywhere
            </p>
            <h3 className="mt-2 text-2xl font-bold text-cove">
              Preset runs wherever you need it
            </h3>
            <p className="mt-2 text-base text-dark-grey">
              Preset Cloud is one option. We also offer managed private cloud,
              on-prem, and self-hosted distributions.
            </p>
            <Link
              to="/deploy-anywhere/"
              className="mt-4 inline-block font-bold text-lush hover:underline"
            >
              Compare all deployment models &rarr;
            </Link>
          </div>
          <div className="grid grid-cols-2 gap-3 md:gap-4">
            {MODELS.map((model) => (
              <Link
                key={model.name}
                to={model.path}
                className="rounded-xl border border-black-squeeze bg-white px-4 py-3 transition-shadow hover:shadow-sm"
              >
                <p className="text-sm font-bold text-cove">{model.name}</p>
                <p className="text-xs text-dark-grey">{model.desc}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </Container>
  )
}

export default DeploymentCalloutSection
